export const KEYBOARD_CHARACTERS = {
  LINE_NUM: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  LINE1: ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  LINE2: ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
  LINE3: ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
};
